export default (function (doc, win) {
  const docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      console.log(clientWidth)
      if (!clientWidth) return;
      docEl.style.fontSize = 32 * (clientWidth / 1920) + 'px';
      if(clientWidth <= 1024) {
        window.location.href = "https://fyit.cc/m.yunlaba/";
      }
    }

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);




// WEBPACK FOOTER //
// ./src/js/resize.js